import { createStore } from "./createStore";
import { SCREENS } from "@/features/tutor/constants";

const base = (set, get) => ({
  sessionId: null,
  currentScreen: SCREENS.INTRO,
  previousScreen: null,
  sessionEnded: false,
  isPhaseSet: false,

  setSessionId: (id) => set({ sessionId: id }),
  getSessionId: () => get().sessionId,
  setCurrentScreen: (screen) => set({ currentScreen: screen }),
  setPreviousScreen: (screen) => set({ previousScreen: screen }),
  setSessionEnded: (val) => set({ sessionEnded: val }),
  setIsPhaseSet: (val) => set({ isPhaseSet: val }),
});

export const useSessionStore = createStore("SessionStore", base);
